import { useEffect, useRef } from 'react'
import { Dialog, NavigationItem } from '@cinesend/ui-kit'
import {
  Airplane,
  Buildings,
  CalendarBlank,
  ListBullets,
  Pulse,
  ShieldCheck,
  User as UserIcon,
} from '@phosphor-icons/react'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Airlines from '../../pages/airlines'
import Airline from '../../pages/airline'
import Cycles from '../../pages/cycles'
import Schemas from '../../pages/schemas'
import Schema from '../../pages/schema'
import Validators from '../../pages/validators'
import Users from '../../pages/users'
import UserPage from '../../pages/user'
import Organizations from '../../pages/organizations'
import Organization from '../../pages/organization'
import ActivityLogs from '../../pages/activity_logs'

const SECTIONS = [
  { label: 'Airlines', to: '/settings/airlines', icon: Airplane },
  { label: 'Cycles', to: '/settings/cycles', icon: CalendarBlank },
  { label: 'Schemas', to: '/settings/schemas', icon: ListBullets },
  { label: 'Validators', to: '/settings/validators', icon: ShieldCheck },
  { label: 'Users', to: '/settings/users', icon: UserIcon },
  { label: 'Organizations', to: '/settings/organizations', icon: Buildings },
  { label: 'Activity Logs', to: '/settings/activity-logs', icon: Pulse },
]

const AdministrationModal = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const scrollerRef = useRef(null)

  useEffect(() => {
    scrollerRef.current?.scrollTo(0, 0)
  }, [pathname])

  const close = () => {
    const back = localStorage.getItem('backToMetadata')
    localStorage.removeItem('backToMetadata')
    navigate(back && !back.startsWith('/settings') ? back : '/')
  }

  return (
    <Dialog
      open
      title='Administration'
      size='xl'
      hasActions={false}
      className='cs-administration-dialog'
      onOpenChange={(open) => {
        if (!open) close()
      }}
    >
      <div className='flex min-h-0 flex-1 overflow-hidden'>
        <nav aria-label='Administration' className='flex w-64 shrink-0 flex-col gap-1 overflow-y-auto p-2'>
          {SECTIONS.map((section) => {
            const Icon = section.icon
            const active = pathname === section.to || pathname.startsWith(`${section.to}/`)
            return (
              <NavigationItem
                key={section.to}
                active={active}
                aria-current={active ? 'page' : undefined}
                icon={<Icon size={20} weight='regular' aria-hidden='true' />}
                onClick={() => navigate(section.to)}
              >
                {section.label}
              </NavigationItem>
            )
          })}
        </nav>
        <div ref={scrollerRef} className='min-h-0 min-w-0 flex-1 overflow-y-auto px-6 py-4'>
          <Routes>
            <Route path='/settings/airlines' element={<Airlines />} />
            <Route path='/settings/airlines/:airlineID/*' element={<Airline />} />
            <Route path='/settings/cycles' element={<Cycles />} />
            <Route path='/settings/schemas' element={<Schemas />} />
            <Route path='/settings/schemas/:schemaID/*' element={<Schema />} />
            <Route path='/settings/validators' element={<Validators />} />
            <Route path='/settings/validators/*' element={<Validators />} />
            <Route path='/settings/users' element={<Users />} />
            <Route path='/settings/users/:userID/*' element={<UserPage />} />
            <Route path='/settings/organizations' element={<Organizations />} />
            <Route path='/settings/organizations/:orgID' element={<Organization />} />
            <Route path='/settings/activity-logs' element={<ActivityLogs />} />
            <Route path='/settings/*' element={<Navigate to='/settings/airlines' replace />} />
          </Routes>
        </div>
      </div>
    </Dialog>
  )
}

export default AdministrationModal
